/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ConvocationResignationEligibleFormativeAction model module.
 * @module model/ConvocationResignationEligibleFormativeAction
 * @version 1.0.0
 */
class ConvocationResignationEligibleFormativeAction {
    /**
     * Constructs a new <code>ConvocationResignationEligibleFormativeAction</code>.
     * @alias module:model/ConvocationResignationEligibleFormativeAction
     */
    constructor() { 
        
        ConvocationResignationEligibleFormativeAction.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConvocationResignationEligibleFormativeAction</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConvocationResignationEligibleFormativeAction} obj Optional instance to populate.
     * @return {module:model/ConvocationResignationEligibleFormativeAction} The populated <code>ConvocationResignationEligibleFormativeAction</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConvocationResignationEligibleFormativeAction();

            if (data.hasOwnProperty('enroll_id')) {
                obj['enroll_id'] = ApiClient.convertToType(data['enroll_id'], 'Number');
            }
            if (data.hasOwnProperty('abbr')) {
                obj['abbr'] = ApiClient.convertToType(data['abbr'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('is_ordinary_eligible')) {
                obj['is_ordinary_eligible'] = ApiClient.convertToType(data['is_ordinary_eligible'], 'Boolean');
            }
            if (data.hasOwnProperty('is_extraordinary_eligible')) {
                obj['is_extraordinary_eligible'] = ApiClient.convertToType(data['is_extraordinary_eligible'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * The formative action enroll id.
 * @member {Number} enroll_id
 */
ConvocationResignationEligibleFormativeAction.prototype['enroll_id'] = undefined;

/**
 * The formative action abbreviation.
 * @member {String} abbr
 */
ConvocationResignationEligibleFormativeAction.prototype['abbr'] = undefined;

/**
 * The formative action name.
 * @member {String} title
 */
ConvocationResignationEligibleFormativeAction.prototype['title'] = undefined;

/**
 * Whether the formative action's enroll is eligible for the ordinary convocation resignation.
 * @member {Boolean} is_ordinary_eligible
 */
ConvocationResignationEligibleFormativeAction.prototype['is_ordinary_eligible'] = undefined;

/**
 * Whether the formative action's enroll is eligible for the extraordinary convocation resignation.
 * @member {Boolean} is_extraordinary_eligible
 */
ConvocationResignationEligibleFormativeAction.prototype['is_extraordinary_eligible'] = undefined;






export default ConvocationResignationEligibleFormativeAction;

